var $692a4298b6b649a2$exports = {};
$692a4298b6b649a2$exports = {
    "Empty": `Tom`
};


export {$692a4298b6b649a2$exports as default};
//# sourceMappingURL=da-DK.module.js.map
